// extracted by mini-css-extract-plugin
export default {"dark":"Header_dark__5Fs0T","header-wrapper":"Header_header-wrapper__czR8r","toggle":"Header_toggle__Fdh+y","light":"Header_light__1SvF+"};